// import React from "react";
// import Box from '@mui/material/Box';
// import { DataGrid } from "@mui/x-data-grid";
// import "../Plagiarism/Plagiarism_1.css";

// const DataGridMui = ({ height, getRowId, rows, columns, checkboxSelection,width }) => {

//     return (
//         <Box sx={{
//             height: height || "47vh", // Default height, can be customized
//             width: width || "70vw", 
//             overflowY: "auto",
//             overflowX: "auto", // Prevent horizontal overflow
//             // border: "10px solid red",
//             // '@media (max-width: 600px)': {
//             //     border: "5px solid red",
//             // }
//             marginLeft: "5px",
            
//         }}>
//             <DataGrid
//                 sx={{
//                     borderColor: "secondary",
//                     "& .MuiDataGrid-cell:hover": {
//                         color: "primary.main",
//                     },
//                     "& .MuiDataGrid-columnHeader": {
//                         backgroundColor: "#1976D2",
//                         fontSize: "12px",
//                         color: "white",
//                         padding: "10px",
//                     },
//                     "& .MuiDataGrid-cell": {
//                         fontSize: "10px",
//                         padding: "8px",
//                         borderRight: "1px solid #e0e0e0",
//                         '@media (max-width: 600px)': {
//                             fontSize: "8px", // Smaller font size for mobile
//                             padding: "6px",  // Smaller padding for mobile
//                         },
//                     },
//                     '&.Mui-selected': {
//                         '&:hover': {
//                             backgroundColor: '#FF0000',
//                         },
//                     },
//                 }}
//                 getRowId={getRowId}
//                 rows={rows}
//                 columns={columns.map(column => ({
//                     ...column,
//                     flex: 1,  // Columns will flex to fill available space
//                     minWidth: 100, // Minimum width to prevent columns from shrinking too much
//                 }))}
//                 disableRowSelectionOnClick
//                 checkboxSelection={checkboxSelection}
//                 rowHeight={30}
//                 hideFooter
//                 disableMultipleColumnsSorting
//                 sortModel={[
//                     { field: "action1", sort: "asc" },
//                     { field: "action", sort: "asc" },
//                 ]}
//             />
//         </Box>
//     );
// }

// export default DataGridMui;


import React from "react";
import Box from '@mui/material/Box';
import { DataGrid } from "@mui/x-data-grid";
import "../Plagiarism/Plagiarism_1.css";

const DataGridMui = ({ height, getRowId, rows, columns, checkboxSelection, width }) => {
    return (
        <Box sx={{
            height: height || "70vh",
            width: width || "90vw",
            overflowY: "auto",
            overflowX: "auto",
            marginLeft: "5px",
            '& .MuiDataGrid-root': {
                border: 'none',
            }
        }}>
            <DataGrid
                sx={{
                    border: 'none',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                    backgroundColor: '#ffffff',
                    
                    // Column Headers - Modern gradient style
                    "& .MuiDataGrid-columnHeaders": {
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '12px 12px 0 0',
                        borderBottom: 'none',
                        minHeight: '56px !important',
                        maxHeight: '56px !important',
                    },
                    "& .MuiDataGrid-columnHeader": {
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#ffffff",
                        padding: "12px 16px",
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        '&:focus': {
                            outline: 'none',
                        },
                        '&:focus-within': {
                            outline: 'none',
                        }
                    },
                    
                    // Column Separators
                    "& .MuiDataGrid-columnSeparator": {
                        color: 'rgba(255, 255, 255, 0.29)',
                    },
                    
                    // Cells - Clean modern look
                    "& .MuiDataGrid-cell": {
                        fontSize: "12px",
                        padding: "12px 16px",
                        borderRight: "1px solid #f0f0f0",
                        borderBottom: "1px solid #f5f5f5",
                        color: '#2c3e50',
                        transition: 'all 0.2s ease',
                        '&:focus': {
                            outline: 'none',
                        },
                        '&:focus-within': {
                            outline: 'none',
                        },
                        '@media (max-width: 600px)': {
                            fontSize: "10px",
                            padding: "8px 12px",
                        },
                    },
                    
                    // Row Hover Effect
                    "& .MuiDataGrid-row": {
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#f8f9ff',
                            transform: 'scale(1.001)',
                            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.1)',
                            cursor: 'pointer',
                        },
                        '&.Mui-selected': {
                            backgroundColor: '#b6bffeff',
                            '&:hover': {
                                backgroundColor: '#b9babcc7',
                            },
                        },
                    },
                    
                    // Cell Hover
                    "& .MuiDataGrid-cell:hover": {
                        color: "#667eea",
                    },
                    
                    // Checkbox Styling
                    "& .MuiCheckbox-root": {
                        color: '#667eea',
                        '&.Mui-checked': {
                            color: '#667eea',
                        },
                    },
                    
                    // Virtual Scroller
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: '#fafafa',
                    },
                    
                    // Scrollbar Styling
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                        width: '8px',
                        height: '8px',
                    },
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '10px',
                    },
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
                        backgroundColor: '#667eea',
                        borderRadius: '10px',
                        '&:hover': {
                            backgroundColor: '#764ba2',
                        },
                    },
                    
                    // Remove default focus outlines
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': {
                        outline: 'none',
                    },
                }}
                getRowId={getRowId}
                rows={rows}
                columns={columns.map(column => ({
                    ...column,
                    flex: 1,
                    minWidth: 120,
                }))}
                disableRowSelectionOnClick
                checkboxSelection={checkboxSelection}
                rowHeight={48}
                hideFooter
                disableMultipleColumnsSorting
                sortModel={[
                    { field: "action1", sort: "asc" },
                    { field: "action", sort: "asc" },
                ]}
            />
        </Box>
    );
}

export default DataGridMui;
